import { takeLatest, put, call, select } from 'redux-saga/effects';
import { addItemToCart } from 'yoda-interfaces/lib/Cart/CartApi';
import isEmpty from 'lodash/isEmpty';
import GiftCardBannerApi from 'yoda-interfaces/lib/GiftCardBanner/GiftCardBannnerApi';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import { clickEventAnalyticsAction } from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import { ANALYTICS_ACTIONS_CART_ADD } from 'yoda-checkout-components/lib/common/Constants';
import showGlobalLoader from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import { setGiftCardMsg, showGiftCardBanner } from '../actions/GiftCardBannerAction';
import {
    ADD_ITEM_TO_CART_REQUEST,
    INIT_NEW_GIFT_CARD_BANNER_VALUE,
    INIT_GIFT_CARD_BANNER,
} from '../actionTypes/AddItemToCartActionTypes';
import { cartDetailsSaga } from './CartDetailsSaga';

export const cartDetails = (state) => state.cartDetails;
export const giftCardBannerData = (state) => state.giftCardBannerData;

export function* initNewGiftCardBanner(action) {
    let cartData = action.cartDetailsResponse;
    if (!cartData) {
        cartData = yield select(cartDetails);
    }
    if (cartData.gid) {
        try {
            const giftCardBannerDetails = yield select(giftCardBannerData);
            let response = {};
            if (!isEmpty(giftCardBannerDetails.source)) {
                response = {
                    data: giftCardBannerDetails.source,
                    status: 200,
                };
            }
            if (isEmpty(response)) {
                response = yield call(GiftCardBannerApi);
            }
            if (response.status === 200) {
                response.data.gid = cartData.gid;
                const options = {
                    isInitGCBannerAddSuccess: action.isInitGCBannerAddSuccess,
                };
                yield put({ type: INIT_NEW_GIFT_CARD_BANNER_VALUE, data: response.data, options });
            } else {
                yield put(showGiftCardBanner({ value: false }));
            }
        } catch (error) {
            yield put(showGiftCardBanner({ value: false }));
        }
    } else {
        yield put(showGiftCardBanner({ value: false }));
        if (action.isInitGCBannerAddSuccess) {
            const status = {
                freeShipping: true,
                isSuccess: true,
                showGCMsgBanner: true,
            };
            yield put(setGiftCardMsg(status));
        }
    }
}

function* addItemToCartSaga() {
    try {
        const giftCardBannerDetails = yield select(giftCardBannerData);
        const selectedItem = giftCardBannerDetails.selectedValue;
        const { ppId } = selectedItem;
        const skuId = selectedItem.key;

        if (ppId && skuId) {
            const addItemAction = {
                payload: {
                    data: [
                        {
                            ppId,
                            quantity: 1,
                            skuId,
                        },
                    ],
                },
            };
            yield put(showGlobalLoader(true));
            const result = yield call(FactorySaga, addItemToCart, addItemAction);
            if (result.isSuccess) {
                const cartDetailAction = {
                    initiatedFrom: 'add_gc_banner_success',
                };
                yield call(cartDetailsSaga, cartDetailAction);
                yield put(clickEventAnalyticsAction({ name: ANALYTICS_ACTIONS_CART_ADD, skuId }));
            } else {
                const status = {
                    isSuccess: false,
                    showGCMsgBanner: true,
                };
                yield put(setGiftCardMsg(status));
            }
            yield put(showGlobalLoader(false));
        } else {
            const status = {
                isSuccess: false,
                showGCMsgBanner: true,
            };
            yield put(setGiftCardMsg(status));
        }
    } catch (error) {
        const status = {
            isSuccess: false,
            showGCMsgBanner: true,
        };
        yield put(setGiftCardMsg(status));
    }
}

const watchGiftCardBannerSaga = function* watchGiftCardBannerSaga() {
    yield takeLatest(ADD_ITEM_TO_CART_REQUEST, addItemToCartSaga);
    yield takeLatest(INIT_GIFT_CARD_BANNER, initNewGiftCardBanner);
};
watchGiftCardBannerSaga.sagaName = 'watchGiftCardBannerSaga';

export default watchGiftCardBannerSaga;
